<template>
  <div>
    <GmapMarker
      v-for="(location, index) in locations"
      :key="index"
      :position="{ lat: location.geometry.location.lat, lng: location.geometry.location.lng }"
      :clickable="false"
      :draggable="false"
      :icon="icon()"
      :zIndex="2">
    </GmapMarker>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import Constants from '../../../constants'

export default {
  data () {
    return {
      locations: []
    }
  },
  mounted () {
    if (Constants.API_ID === "OKUKYOTO") {
      //初回一回目の表示
      this.$store.dispatch('locations/fetchAll')
        .then(() => {
          this.locations = this.$store.getters['locations/getLocation']().results
        })
      //二回目以降の表示
      setInterval(()=>{
        this.$store.dispatch('locations/fetchAll')
          .then(() => {
            this.locations = this.$store.getters['locations/getLocation']().results
          })
        }, 10000)
    }
  },
  methods: {
    icon: function () {
      if (this.google) {
        return {
          url: require('@/assets/images/den.png'),
          scaledSize: new this.google.maps.Size(24, 24)
        }
      }
    }
  },
  computed: {
    google: gmapApi
  }
}
</script>
